/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {KTSVG} from '../../../helpers'
import {getCSSVariableValue} from '../../../assets/ts/_utils'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'
import {Statistics} from '../../../../app/pages/dashboard/hooks/useStateQuery'

type Props = {
  className: string
  chartColor: string
  strokeColor: string
  chartHeight: string
  statData?: Statistics
}

const MixedWidget2: React.FC<Props> = ({
  className,
  chartColor,
  chartHeight,
  strokeColor,
  statData,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(chartHeight, chartColor, strokeColor)
    )
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className={`card-header border-0 py-5 `} style={{backgroundColor: chartColor}}>
        <h3 className='card-title fw-bold text-white'>Knohow Statistics</h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-color-white btn-active-white btn-active-color- border-0 me-n3'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 /> */}
          {/* end::Menu */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Chart */}
        <div
          // ref={chartRef}
          className={`mixed-widget-2-chart card-rounded-bottom bg-${chartColor} mb-8`}
        ></div>
        {/* end::Chart */}
        {/* begin::Stats */}
        <div className='card-p mt-n10 position-relative'>
          {/* begin::Summary Row */}
          <h4 className='mb-4'>Summary</h4>
          <div className='row g-0 mb-4'>
            <div className='col bg-light-primary px-6 py-8 rounded-2 me-7 mb-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/communication/com006.svg'
                    className='svg-icon-3x svg-icon-primary d-block my-2'
                  />
                  <a href='/providers' className='text-primary fw-semobold fs-6'>
                    Knohow Pros
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-primary'>{statData?.totalKnohowProviders}</h3>
                </div>
              </div>
            </div>
            <div className='col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/general/gen049.svg'
                    className='svg-icon-3x svg-icon-warning d-block my-2'
                  />
                  <a href='/providers' className='text-warning fw-semobold fs-6'>
                    Non-Knohow Pros
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-warning'>{statData?.totalNonKnohowPros}</h3>
                </div>
              </div>
            </div>
            <div className='col bg-light-danger px-6 py-8 rounded-2 mb-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3x svg-icon-danger d-block my-2'
                  />
                  <a href='/providers' className='text-danger fw-semobold fs-6'>
                    Google Pros
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-danger'>{statData?.totalGooglePros}</h3>
                </div>
              </div>
            </div>
          </div>
          <div className='row g-0 mb-7'>
            <div className='col bg-light-success px-6 py-8 rounded-2 me-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/general/gen030.svg'
                    className='svg-icon-3x svg-icon-success d-block my-2'
                  />
                  <a href='/favorites' className='text-success fw-semobold fs-6'>
                    Knohow Favs
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-success'>{statData?.totalKnohowFavs}</h3>
                </div>
              </div>
            </div>
            <div className='col bg-light-info px-6 py-8 rounded-2 me-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/communication/com013.svg'
                    className='svg-icon-3x svg-icon-info d-block my-2'
                  />
                  <a href='/members' className='text-info fw-semobold fs-6'>
                    Knohow Members
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-info'>{statData?.totalKnohowClients}</h3>
                </div>
              </div>
            </div>
            <div className='col bg-light-dark px-6 py-8 rounded-2'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/communication/com014.svg'
                    className='svg-icon-3x svg-icon-dark d-block my-2'
                  />
                  <a href='/members' className='text-dark fw-semobold fs-6'>
                    Non-Knohow Members
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-dark'>{statData?.totalNonKnohowClients}</h3>
                </div>
              </div>
            </div>
          </div>
          {/* end::Summary Row */}

          {/* begin::Row */}
          {/* channels */}
          <h4>Channels</h4>
          <div className='row g-0'>
            {/* begin::Col */}
            <div className='col bg-light-dark px-6 py-8 rounded-2 me-7 mb-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/layouts/lay002.svg'
                    className='svg-icon-3x svg-icon-dark d-block my-2'
                  />
                  <a href='/channels' className='text-dark fw-semobold fs-6'>
                    Channels(I)
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-dark'>{statData?.totalRootServices}</h3>
                </div>
              </div>
            </div>
            {/* end::Col */}
            {/* begin::Col */}
            <div className='col bg-light-primary px-6 py-8 rounded-2 me-7 mb-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/layouts/lay008.svg'
                    className='svg-icon-3x svg-icon-primary d-block my-2'
                  />
                  <a href='/channels' className='text-primary fw-semobold fs-6'>
                    Sub Channels(II)
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-primary'>{statData?.totalLevel2Services}</h3>
                </div>
              </div>
            </div>
            {/* end::Col */}
            {/* begin::Col */}
            <div className='col bg-light-danger px-6 py-8 rounded-2 mb-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/layouts/lay003.svg'
                    className='svg-icon-3x svg-icon-danger d-block my-2'
                  />
                  <a href='/channels' className='text-danger fw-semobold fs-6'>
                    Services(III)
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-danger'>{statData?.totalLevel3Services}</h3>
                </div>
              </div>
            </div>
            {/* end::Col */}
          </div>
          {/* end::Row */}
          {/* begin::Row */}
          {/* appointments */}
          <div className='row g-0'>
            <h4>Appointment</h4>
            {/* begin::Col */}
            <div className='col bg-light-info px-6 py-8 rounded-2 me-7'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/general/gen014.svg'
                    className='svg-icon-3x svg-icon-info d-block my-2'
                  />
                  <a href='appointments' className='text-info fw-semobold fs-6'>
                    Total Appointments
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-info'>{statData?.totalAppointments}</h3>
                </div>
              </div>
            </div>
            {/* end::Col */}
            {/* begin::Col */}
            <div className='col bg-light-success px-6 py-8 rounded-2'>
              <div className='row'>
                <div className='col-6'>
                  <KTSVG
                    path='media/icons/duotune/general/gen014.svg'
                    className='svg-icon-3x svg-icon-success d-block my-2'
                  />
                  <a href='appointments?status=active' className='text-success fw-semobold fs-6'>
                    Active Appointments
                  </a>
                </div>
                <div className='col-6 text-center my-auto'>
                  <h3 className='fs-1 fw-bold text-success'>{statData?.totalActiveAppointments}</h3>
                </div>
              </div>
            </div>
            {/* end::Col */}
          </div>
          {/* end::Row */}
        </div>
        {/* end::Stats */}
      </div>
      {/* end::Body */}
    </div>
  )
}

const chartOptions = (
  chartHeight: string,
  chartColor: string,
  strokeColor: string
): ApexOptions => {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  const color = getCSSVariableValue('--kt-' + chartColor)

  return {
    series: [
      {
        name: 'Net Profit',
        data: [30, 45, 32, 70, 40, 40, 40],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 3,
        color: strokeColor,
        opacity: 0.5,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 0,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [strokeColor],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: {
          color: borderColor,
          width: 1,
          dashArray: 3,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 80,
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val + ' thousands'
        },
      },
      marker: {
        show: false,
      },
    },
    colors: ['transparent'],
    markers: {
      colors: [color],
      strokeColors: [strokeColor],
      strokeWidth: 3,
    },
  }
}

export {MixedWidget2}
